import React, {useEffect, useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import PropTypes from "prop-types";
import Popup from "../Helpers/Popup";
import {ComponentContext} from "../../contexts";
import {input} from "../../utils/linker";

function ExportImport(props) {
  const store = useLocalObservable(() => ({
    show_window: false,
    struct_str: ""
  }));
  const compContext = useContext(ComponentContext);
  useEffect(() => {
    // mount
    store.struct_str = JSON.stringify(compContext.struct);
    return () => {
      // unmount
    }
  }, []);

  const importData=()=>{
    runInAction(()=>{
      store.show_window=false;
      compContext.struct=JSON.parse(store.struct_str);
    });
  };


  return (
    <div>
      <span className="pc1 pointer" onClick={()=>{ runInAction(()=>{ store.show_window=true; }); }}>Экспорт/импорт</span>
      <Popup disablePaddings={false} showed={store.show_window} onHide={()=>{ runInAction(()=>{ store.show_window=false; }); }}>
        <div style={{minWidth: 620}}>
          <h2>Экспорт/импорт</h2>
          <p>Используйте данный интерфейс только для переноса структуры с одного сайта на другой. Не модифицируйте скопированный JSON.</p>
          <div className="pbottom20">
            <textarea {...input(store, 'struct_str')} className="w100 " style={{height:300}} />
          </div>
          <div className="up12 margin">
            <div className="cell s-auto"></div>
            <div className="cell s-shrink">
              <span className="btn2" onClick={()=>{ runInAction(()=>{ store.show_window=false; }); }}><span>Закрыть</span></span>
            </div>
            <div className="cell s-shrink">
              <span className="btn1" onClick={()=>{ importData(); }}><span>Сохранить</span></span>
            </div>
          </div>
        </div>
      </Popup>
    </div>
  )
};

ExportImport.defaultProps = {};

ExportImport.propTypes = {}

export default observer(ExportImport);
